const BREAKPOINTS = {
  XS: 480,
  SM: 576,
  MD: 768,
  LG: 992,
  XL: 1200,
  XXL: 1600
}

type BreakpointsAccumulator = {
  antBreakpoints: Record<string, number>
  tailwindBreakpoints: Record<string, string>
}

const { antBreakpoints, tailwindBreakpoints } = Object.entries(
  BREAKPOINTS
).reduce<BreakpointsAccumulator>(
  (acc, [key, value]) => {
    acc.antBreakpoints[`screen${key}`] = value
    acc.tailwindBreakpoints[key.toLowerCase()] = `${value}px`
    return acc
  },
  {
    antBreakpoints: {},
    tailwindBreakpoints: {}
  }
)

export { BREAKPOINTS, antBreakpoints, tailwindBreakpoints }
